import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) { nav("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState({}, "", "/dashboard");
        nav("/dashboard", { replace: true });
      } catch { setErr("Sign-in failed"); setTimeout(() => nav("/login"), 1500); }
    })();
  }, [location.hash, nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center text-brand-muted">
      {err || "Signing you in…"}
    </div>
  );
}
